import { get, post, put, delete as remove } from 'axios'

const URL = '/culture'

export const getRanking = async groupId => get(`${URL}/ranking/${groupId}`)

export const getRankingHistory = async groupId =>
  get(`${URL}/ranking/${groupId}/history`)

export const getAllValues = async () => get(`${URL}/values`)

export const getDesiredValues = async () => get(`${URL}/desired-values`)

export const removeDesiredValue = async id =>
  remove(`${URL}/desired-values/${id}`)

export const saveDesiredValue = async ({ desiredValue }) =>
  post(`${URL}/desired-values`, { desiredValue })

export const updateDesiredValue = async ({ desiredValue }) =>
  put(`${URL}/desired-values/${desiredValue.id}`, { desiredValue })
